import { capitalize } from 'lodash'

import { RequestTicketState } from '../typings/types'

export const getStateName = (name: string) => {
  if (name === RequestTicketState.RESOLVED) {
    return 'Needs Moderation'
  }

  return name
    .split('_')
    .map(capitalize)
    .join(' ')
}



// WEBPACK FOOTER //
// ./src/helpers/state-helper.ts